export default __webpack_public_path__ + "static/hp-pharmaco-ferritin-chart-LG-1f10b086f66e0d5d726194ccf9934eaa.png";